import { gunterzBold } from '@/theme/fonts';
import { Card, Group, NumberFormatter, Text } from '@mantine/core';
export type TransactionCoinCardProps = {
  unit: string;
  coin: number;
  money: number;
};
export const TransactionCoinCard: React.FC<TransactionCoinCardProps> = ({
  unit,
  coin,
  money
}) => {
  return <Card radius={5} bg="var(--navbar-bg-color)" w={{
    base: '50%',
    sm: 315
  }} p={{
    base: 10,
    sm: 20
  }}>
      <Text fw={700} c="var(--text-prime)" fz={{
      base: 12,
      md: 13
    }} tt="uppercase">
        {unit}
      </Text>
      <Group wrap="nowrap" gap={4}>
        <Text fw={700} c="var(--text-white)" fz={{
        base: 21,
        sm: 32
      }} className={gunterzBold.className}>
          <NumberFormatter value={coin} thousandSeparator="," decimalSeparator="." decimalScale={4} />
        </Text>
        <Text fw={700} c="var(--text-dark)" fz={{
        base: 10,
        sm: 14
      }} style={{
        textWrap: 'nowrap'
      }}>
          /{' '}
          <NumberFormatter value={money} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale prefix="$" suffix=" USD" />
        </Text>
      </Group>
    </Card>;
};